<div *ngIf="successMessage" class="alert alert-success" role="alert">
        <mat-icon>thumb_up</mat-icon> &nbsp;
        <label style="vertical-align: text-bottom; margin-bottom: 0rem;">
                {{successMessage}}
        </label>
</div>
<div *ngIf="errorMessage" class="alert alert-danger" role="alert">
        <label style="vertical-align: text-bottom; margin-bottom: 0rem;">
                {{errorMessage}}
        </label>
</div>
<div class="row_1">
        <div class="top_grid_agg">
                <div class="content">
                        <button class="refresh_button" (click)="refreshData()">REFRESH</button>
                        <button class="add_button" (click)="openDialog()" title="Add Holiday(s)">ADD</button>
                </div>
                <div class="grid-agg">
                        <ag-grid-angular #agGrid [ngStyle]="{'height': dynamicHeight + 'px',
                        'width':'100%' }" id="myGrid" class="ag-theme-balham" [pagination]="setPagination"
                                [columnDefs]="columnDefs" [rowData]="rowData" [icons]="icons"
                                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
                                [paginationPageSize]="paginationPageSize" (gridReady)="onGridReady($event)"
                                (window:resize)="sizeToFit()" [context]="context" [icons]="icons" [theme]="'legacy'"
                                [enableCellTextSelection]="true" [ensureDomOrder]="true"
                                (filterChanged)="onFilterChanged($event)"></ag-grid-angular>
                        <div class="custom-pagination" *ngIf="totalRecords > 0">
                                <div class="left">
                                        <span class="records-per-page">
                                                <span>Records/Page : </span>
                                                <select [(ngModel)]="rpPage" (change)="rppChanged($event)">
                                                        <option *ngFor="let size of pgDropDown" [value]="size.value">{{
                                                                size.value }}</option>
                                                </select>
                                        </span>
                                </div>
                                <div class="right">
                                        <span class="viewing-records">
                                                <span class="w-600">{{sRecord}}</span> to <span
                                                        class="w-600">{{eRecord}}</span> of <span
                                                        class="w-600">{{totalRecords}}</span>
                                                <button (click)="goToFirstPage()"
                                                        [disabled]="getCurrentPage() === true"><i
                                                                class="fa-solid fa-backward-fast"
                                                                [ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                                                <button (click)="goToPreviousPage()"
                                                        [disabled]="getCurrentPage() === true"><i
                                                                class="fa-solid fa-backward-step"
                                                                [ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                                                <span>Page <span class="w-600">{{cPage}}</span> of <span
                                                                class="w-600">{{tPage}}</span></span>
                                                <button (click)="goToNextPage()" [disabled]="isLastPage() === true"><i
                                                                class="fa-solid fa-forward-step"
                                                                [ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                                                <button (click)="goToLastPage()" [disabled]="isLastPage() === true"><i
                                                                class="fa-solid fa-forward-fast"
                                                                [ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                                        </span>
                                </div>
                        </div>
                </div>
        </div>
</div>